import { render, staticRenderFns } from "./gk_corpus.vue?vue&type=template&id=11267145&scoped=true"
import script from "./gk_corpus.vue?vue&type=script&lang=js"
export * from "./gk_corpus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11267145",
  null
  
)

export default component.exports